import { yupResolver } from "@hookform/resolvers/yup";
import type { FormEvent } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import * as yup from "yup";

import { Button } from "@krea/shared/design-system/Button";
import { ControlledWrapper } from "@krea/shared/design-system/input/controlled-wrapper";
import { FieldDescription } from "@krea/shared/design-system/input/field";
import { AppModal } from "@krea/shared/design-system/modal";
import { Textarea } from "@krea/shared/design-system/Textarea";

import { RejectedByLenderReasonEnum } from "@/features/common/enums";
import { useRejectApplicationMutation } from "@/features/lender-applications/hooks/data/usereject-application.mutation";
import type { IApplyingCompanyExtended } from "@/features/lender-applications/types/applying-company";

const schema = yup.object().shape({
  explanation: yup.string().required("Explanation is required."),
});

interface IRejectApplicationModalProps {
  customerCompany: IApplyingCompanyExtended["customerCompany"];
  lenderApplicationId: number;

  setOpen: (isOpen: boolean) => void;
}

const RejectApplicationModal = ({
  customerCompany,
  lenderApplicationId,

  setOpen,
}: IRejectApplicationModalProps) => {
  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      explanation: undefined,
    },
  });

  const { lenderCompanyId } = useParams<{ lenderCompanyId: string }>();

  const { mutate: rejectApplication, isPending: isModalLoading } =
    useRejectApplicationMutation();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    form.handleSubmit((data) => {
      rejectApplication(
        {
          lenderApplicationId,
          lenderCompanyId: Number(lenderCompanyId),
          data: {
            rejectedByLenderDescription: data.explanation,
            rejectedByLenderReason: RejectedByLenderReasonEnum.LENDER_DECISION,
          },
        },
        {
          onSuccess: () => {
            setOpen(false);
          },
        },
      );
    })(e);
  };

  const onCloseModal = () => {
    setOpen(false);
  };

  return (
    <AppModal
      open={true}
      setOpen={setOpen}
      onClose={onCloseModal}
      title={`Reject application #${lenderApplicationId}`}
      footer={
        <>
          <Button variant="secondary" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            form="rejectApplicationForm"
            type="submit"
            disabled={isModalLoading || !form.formState.isValid}
          >
            Reject
          </Button>
        </>
      }
    >
      <h6 className="mb-5">
        {customerCompany.name}{" "}
        {customerCompany.organisationNumber &&
          `(${customerCompany.organisationNumber})`}
      </h6>
      <form onSubmit={handleSubmit} id="rejectApplicationForm">
        <ControlledWrapper
          control={form.control}
          name="explanation"
          label={<span className="font-semibold">Explanation</span>}
          render={({ field }) => (
            <>
              <FieldDescription>
                Writing an explanation helps Krea to understand why you rejected
                the application. This information is not shown to the customer.
              </FieldDescription>
              <Textarea
                {...field}
                placeholder="Enter explanation"
                required={true}
              />
            </>
          )}
        />
      </form>

      {/* <Button
        variant="danger"
        form="rejectApplicationForm"
        type="submit"
        disabled={isModalLoading || !form.formState.isValid}
      >
        Reject
      </Button> */}
    </AppModal>
  );
};

export default RejectApplicationModal;
